import { Route, Routes } from 'react-router-dom';
import { Dropdown } from "react-materialize";
import { Link } from 'react-router-dom';
import { HashLink } from "react-router-hash-link";

import "./App.css";// this is required, probably by web-pack when building
import 'materialize-css';

import Home from './Home';
import AboutBostonTerrier from './AboutBostonTerrier';
import AboutChika from './dams/Chika';
import AboutSierra from './dams/Sierra';
import AboutDiva from './dams/Diva';
import BreedA from "./breeds/BreedA";
import BreedB from "./breeds/BreedB";
import BreedC from "./breeds/BreedC";
import BreedD from "./breeds/BreedD";
import BreedE from "./breeds/BreedE";

export default function App() {
  return (
    <div>

      <header>
        <div className="navbar-fixed">
          <nav role="navigation">
            <div className="nav-wrapper container">
              <a href="/" data-target="sidenav" className="sidenav-trigger">
                <i className="material-icons">menu</i>
              </a>
              <a className="brand-logo hide-on-med-and-down" href="/">
                <div className="valign-wrapper">
                  <p>Bostono terjerai</p>
                  <img src="images/logo.png" alt="logo" height="80px" />
                </div>
              </a>
              <ul id="nav-mobile" className="right valign-wrapper hide-on-med-and-down">
                <li><HashLink to="/#musu-sunys">Mūsų šunys</HashLink></li>
                <li>
                  <Dropdown trigger={
                    <a href="!">Mūsų paskutinė vada</a>
                  }
                  >
                    <HashLink to="/#naujausia-suniuku-vada">Naujausia vada</HashLink>
                    <li className="divider"></li>
                    <Link to="breed-a">A vada</Link>
                    <Link to="breed-b">B vada</Link>
                    <Link to="breed-c">C vada</Link>
                    <Link to="breed-d">D vada</Link>
                    <Link to="breed-e">E vada</Link>
                  </Dropdown>
                </li>
                <li>
                  <HashLink to="#kontaktai">Kontaktai</HashLink>
                </li>
              </ul>
            </div>
          </nav>
          <ul className="sidenav" id="sidenav">
            <li><HashLink to="/#musu-sunys">Mūsų šunys</HashLink></li>
            <li>
              <Dropdown trigger={
                <a href="!">Mūsų paskutinė vada</a>
              }
              >
                <HashLink to="/#naujausia-suniuku-vada">Naujausia vada</HashLink>
                <li className="divider"></li>
                <Link to="breed-a">A vada</Link>
                <Link to="breed-b">B vada</Link>
                <Link to="breed-c">C vada</Link>
                <Link to="breed-d">D vada</Link>
                <Link to="breed-e">E vada</Link>
              </Dropdown>
            </li>
            <li>
              <HashLink to="#kontaktai">Kontaktai</HashLink>
            </li>
          </ul>



        </div>

      </header>

      <main>
        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route path="/about-boston-terrier" element={<AboutBostonTerrier />} />
          <Route path="/about-chika" element={<AboutChika />} />
          <Route path="/about-sierra" element={<AboutSierra />} />
          <Route path="/about-diva" element={<AboutDiva />} />
          <Route path="/breed-a" element={<BreedA />} />
          <Route path="/breed-b" element={<BreedB />} />
          <Route path="/breed-c" element={<BreedC />} />
          <Route path="/breed-d" element={<BreedD />} />
          <Route path="/breed-e" element={<BreedE />} />
        </Routes>
      </main>

      <footer className="page-footer" id="kontaktai">
        <div className="container">
          <div className="row">
            <div className="col l4 s12">
              <img src="images/love.png" alt="love" />
              <h5>AČIŪ</h5>
              <p className="light">Dėkojame, kad skyrėte laiko ir apsilankėte mūsų puslapyje.</p>
            </div>
            <div className="col l4 s12">
              <div className="center"><img src="images/message.png" alt="message" /> </div>

              <h5 >SUSISIEKITE SU MUMIS</h5>
              <address className="light">
                Parašykite mums e-laišką <a href="mailto:bostonoterjerai@gmail.com">bostonoterjerai@gmail.com</a> <br />arba paskambinkite <br /><a href="tel:+37060128730">+370 601 28730</a>
              </address>
            </div>
            <div className="col l4 s12">
              <div className="row">
                <div className="right">
                  <a href="https://www.instagram.com/bostonoterjerai/" target="_blank" rel="noopener noreferrer"><img src="images/instagram.png" alt="instagram" /></a>
                  <a href="https://www.facebook.com/BostonoTerjerai/" target="_blank" rel="noopener noreferrer"><img src="images/facebook.png" alt="facebook" /></a>
                </div>
              </div>
              <p className="light">Sekite naujienas mūsų <a href="https://www.facebook.com/BostonoTerjerai/" target="_blank" rel="noopener noreferrer"> Facebook </a>
                arba <a href="https://www.instagram.com/bostonoterjerai/" target="_blank" rel="noopener noreferrer"> Instagram </a> paskyroje.
              </p>
            </div>
          </div>
        </div>
        <div className="footer-copyright">
          <div className="container"> Bostono Terjerai &copy; 2017 - 2022.</div>
        </div>
      </footer>
    </div >
  );

}

